import { Link } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useCompare } from '@/contexts/CompareContext';

export function CompareBar() {
  const { compareList, removeFromCompare, clearCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background/95 backdrop-blur-xl shadow-lg">
      <div className="container flex items-center justify-between gap-4 py-3">
        <div className="flex items-center gap-3 flex-1 min-w-0 overflow-x-auto">
          <span className="text-sm font-medium text-muted-foreground shrink-0">
            Compare ({compareList.length}/5):
          </span>
          {compareList.map((c) => (
            <Badge key={c.id} variant="secondary" className="gap-1 shrink-0">
              {c.name}
              <button
                onClick={() => removeFromCompare(c.id)}
                className="ml-1 hover:text-destructive"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="ghost" size="sm" onClick={clearCompare}>
            Clear
          </Button>
          <Button asChild size="sm" disabled={compareList.length < 2}>
            <Link to="/companies/compare">
              Compare <ArrowRight className="h-3 w-3 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
